<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="66"
    height="22"
    viewBox="0 0 66 22"
  >
    <g id="Group_4716" data-name="Group 4716" transform="translate(-29 -32)">
      <rect
        id="Rectangle_1499"
        data-name="Rectangle 1499"
        width="66"
        height="22"
        rx="11"
        transform="translate(29 32)"
        fill="#b40068"
      />
      <path
        id="Path_2383"
        data-name="Path 2383"
        d="M3.912.168A2.915,2.915,0,0,0,7.128-2.748V-8.4H5.472v5.52c0,.816-.432,1.428-1.56,1.428s-1.56-.612-1.56-1.428V-8.4H.708v5.652A2.911,2.911,0,0,0,3.912.168Zm8.364-6.336a2.331,2.331,0,0,0-1.944.876V-6H8.784V2.4h1.548V-.708a2.331,2.331,0,0,0,1.944.876A3.037,3.037,0,0,0,15.2-3,3.037,3.037,0,0,0,12.276-6.168Zm-.288,4.86A1.61,1.61,0,0,1,10.332-3a1.61,1.61,0,0,1,1.656-1.692A1.613,1.613,0,0,1,13.656-3,1.613,1.613,0,0,1,11.988-1.308ZM21.132-6v.744a2.293,2.293,0,0,0-1.92-.912A3.007,3.007,0,0,0,16.224-3.1,3,3,0,0,0,19.212-.024a2.293,2.293,0,0,0,1.92-.912v.648A1.4,1.4,0,0,1,19.56,1.188a1.559,1.559,0,0,1-1.572-.84l-1.32.756a3.038,3.038,0,0,0,2.844,1.464A2.847,2.847,0,0,0,22.644-.288V-6Zm-1.68,4.548A1.6,1.6,0,0,1,17.772-3.1a1.6,1.6,0,0,1,1.68-1.632A1.6,1.6,0,0,1,21.132-3.1,1.6,1.6,0,0,1,19.452-1.452Zm6.384-3.516V-6H24.288V0h1.548V-2.868A1.5,1.5,0,0,1,27.66-4.392V-6.12A1.847,1.847,0,0,0,25.836-4.968ZM33.132-6v.708a2.389,2.389,0,0,0-1.956-.876A3.035,3.035,0,0,0,28.26-3,3.035,3.035,0,0,0,31.176.168a2.389,2.389,0,0,0,1.956-.876V0H34.68V-6ZM31.464-1.308A1.61,1.61,0,0,1,29.808-3a1.61,1.61,0,0,1,1.656-1.692A1.613,1.613,0,0,1,33.132-3,1.613,1.613,0,0,1,31.464-1.308ZM40.872-8.4v3.108a2.331,2.331,0,0,0-1.944-.876A3.037,3.037,0,0,0,36-3,3.037,3.037,0,0,0,38.928.168a2.331,2.331,0,0,0,1.944-.876V0H42.42V-8.4ZM39.216-1.308A1.613,1.613,0,0,1,37.548-3a1.613,1.613,0,0,1,1.668-1.692A1.61,1.61,0,0,1,40.872-3,1.61,1.61,0,0,1,39.216-1.308Zm6.168-1.056h4.524A3.576,3.576,0,0,0,49.968-3a3.033,3.033,0,0,0-3.036-3.168A3.063,3.063,0,0,0,43.764-3,3.088,3.088,0,0,0,47.052.168a3.036,3.036,0,0,0,2.616-1.284l-1.248-.72a1.663,1.663,0,0,1-1.344.6A1.575,1.575,0,0,1,45.384-2.364Zm-.024-1.2a1.5,1.5,0,0,1,1.572-1.212A1.456,1.456,0,0,1,48.42-3.564Z"
        transform="translate(36.792 46.4)"
        fill="#fff"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Padlock',
}
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
}
</style>
